<div class="w-full relative">
    <!-- Navigation Arrows -->
    <button
        class="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-full -ml-1.5 z-10 w-8 h-8 rounded-full bg-black text-white flex items-center justify-center hover:bg-gray-800 transition-colors hidden md:flex"
        (click)="navigatePrevious()">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
        </svg>
    </button>
    <button
        class="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full ml-1.5 z-10 w-8 h-8 rounded-full bg-black text-white flex items-center justify-center hover:bg-gray-800 transition-colors hidden md:flex"
        (click)="navigateNext()">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
        </svg>
    </button>

    <!-- Tab Headers -->
    <div class="overflow-x-auto whitespace-nowrap border-b border-gray-300 bg-gray-100 text-sm font-medium font-gotham">
        <div class="flex flex-nowrap w-max">
            <ng-container *ngFor="let key of tabKeys">
                <button
                    class="px-6 py-4 border-b-4 transition-colors font-[500] duration-200 whitespace-nowrap"
                    [class.border-yellow-400]="selected === key"
                    [class.bg-white]="selected === key"
                    [class.text-black]="selected === key"
                    [class.text-gray-600]="selected !== key"
                    (click)="select(key)">
                    {{ key }}
                </button>
            </ng-container>
        </div>
    </div>

    <!-- Tab Content -->
    <div class="py-8">
        <ng-container *ngTemplateOutlet="selectedTemplate"></ng-container>
    </div>
</div>
